<cars-tdif-normal-clause *ngIf="content?.getIdentifier() === 'clause'" [content]="content"> </cars-tdif-normal-clause>

<cars-tdif-heading-clause
  *ngIf="content?.getIdentifier() === 'headingClause'"
  [content]="content"
></cars-tdif-heading-clause>
